import { Platform } from '@ionic/angular';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

import { Price, Product } from 'src/app/interfaces/product';
import { AccountProductList } from 'src/app/commons/product';
import { AccountInfoService } from 'src/app/services/account/account-info.service';
import { AccountInfo } from 'src/app/interfaces/account';
import { PriceType } from 'src/app/types/product';

@Injectable({
  providedIn: 'root'
})
export class ProductAccountService implements OnInit, OnDestroy {

  /**
   * Upgrade mode
   */
  upgradeMode: boolean;
  /**
   * Upgrade trial
   */
  upgradeTrial: boolean;
  /**
   * Observable upgrade mode
   */
  observableUpgradeMode: any;
  /**
   * Observable upgrade trial
   */
  observableUpgradeTrial: any;

  /**
   * Account info
   */
  private accountInfo: AccountInfo;
  /**
   * Account info subscription
   */
  private accountInfoSubscription: Subscription;

  /**
   * Constructor
   * @param platform Platform
   * @param accountInfoService account info service
   */
  constructor(
    private platform: Platform,
    private accountInfoService: AccountInfoService,
  ) {
    this.observableUpgradeMode = new BehaviorSubject<boolean>(this.upgradeMode);
    this.observableUpgradeTrial = new BehaviorSubject<boolean>(this.upgradeTrial);
    this.watchAccountInfo();  
  }

  ngOnInit(): void {
     
  }

  ngOnDestroy() {
    this.unwatchAccountInfo();
  }

  /**
   * Watch account info
   */
  async watchAccountInfo() {
    if (!this.accountInfoSubscription) {
      this.accountInfoSubscription = this.accountInfoService.observableAccountInfo.subscribe((accountInfo: AccountInfo) => {
        this.accountInfo = accountInfo;
  
        if (this.accountInfo?.accountId && this.accountInfo?.accountStatus?.premium && this.accountInfo?.accountType !== 'full') {
          if (!this.upgradeMode) {
            this.upgradeMode = true;
            this.observableUpgradeMode.next(this.upgradeMode);
          }
        } else {
          if (this.upgradeMode) {
            this.upgradeMode = false;
            this.observableUpgradeMode.next(this.upgradeMode);
          }
        }
  
        if (this.accountInfo?.accountId && !this.accountInfo?.accountStatus?.premium
          && this.accountInfo?.accountStatus?.trial) {
          if (!this.upgradeTrial) {
            this.upgradeTrial = true;
            this.observableUpgradeTrial.next(this.upgradeTrial);
          }
        } else {
          if (this.upgradeTrial) {
            this.upgradeTrial = false;
            this.observableUpgradeTrial.next(this.upgradeTrial);
          }
        }
      });
    }
  }

  /**
   * Unwatch account info
   */
  async unwatchAccountInfo() {
    if (this.accountInfoSubscription) {
      this.accountInfoSubscription.unsubscribe();
      this.accountInfoSubscription = null;
    }
  }

  /**
   * Validate account product id
   * @param productId product ID
   * @returns true if is valid propduct id
   */
  validateProductId(productId: string): string {
    if (productId && AccountProductList?.findIndex((product: Product) => product?.productId === productId) !== -1) {
      if (this.platform.is('hybrid') && productId === 'wedding_account_web') {
        return '';
      } else if (!this.platform.is('hybrid') && productId === 'wedding_account_app') {
        return '';
      } else if (this.upgradeMode && productId !== 'wedding_account_full') {
        return '';
      }
      return productId;
    }
    return '';
  }

  getProductPrice(productId: string, currency: string, priceType: PriceType) {
    if (productId && AccountProductList?.length) {
      const index = AccountProductList?.findIndex((product: Product) => product?.productId === productId);
      if (index !== -1) {
        const product: Product = AccountProductList[index];
        if (priceType === 'original') {
          const currencyIndex = product?.oriPriceList?.findIndex((x: Price) => x.currency === currency);
          if (currencyIndex !== -1) {
            return product.oriPriceList[currencyIndex].amount;
          }
        } else if (priceType === 'selling') {
          const currencyIndex = product?.priceList?.findIndex((x: Price) => x.currency === currency);
          if (currencyIndex !== -1) {
            return product.priceList[currencyIndex].amount;
          }
        }
      }
    }
    return 0;
  }

}
